import { Component } from '@angular/core';

import { CancelComponent } from '../cancel/cancel.component';

@Component({
  selector: 'app-quit-header',
  templateUrl: './quit-header.component.html',
  styleUrls: ['./quit-header.component.scss'],
  standalone: true,
  imports: [CancelComponent],
})
export class QuitHeaderComponent {}
